import { Handle, Position, type NodeProps } from "@xyflow/react";

import type { GtmFlowNodeData } from "../sequenceToFlow";

export default function GtmTerminalNode({ data, selected }: NodeProps) {
  const d = data as GtmFlowNodeData;
  const tone =
    d.stepKey === "meeting"
      ? "border-emerald-200 bg-emerald-50 text-emerald-800"
      : d.stepKey === "hands"
        ? "border-orange-200 bg-orange-50 text-orange-800"
        : "border-gray-200 bg-gray-50 text-gray-700";
  return (
    <div
      className={`nopan min-w-[120px] rounded-lg border px-3 py-2 shadow-sm ${tone} ${
        selected ? "ring-2 ring-offset-1 ring-slate-400" : ""
      }`}
    >
      <Handle type="target" position={Position.Left} className="!bg-slate-400" />
      <div className="text-[10px] font-semibold uppercase tracking-wide opacity-70">End</div>
      <div className="text-sm font-medium">{d.label}</div>
      {typeof d.count === "number" && d.count > 0 ? (
        <div className="mt-1 text-xs font-semibold opacity-80">{d.count}</div>
      ) : null}
    </div>
  );
}
